/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G6_DInputs */

const en_mk_sec_pg_g6_d = /** @type {(inputs: Mk_Sec_Pg_G6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents do not reply to agents in chat, and delegation between agents is bounded so no chain runs away.`)
};

const id_mk_sec_pg_g6_d = /** @type {(inputs: Mk_Sec_Pg_G6_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen tidak membalas agen di chat, dan pendelegasian antar-agen dibatasi supaya tidak ada rantai yang lepas kendali.`)
};

/**
* | output |
* | --- |
* | "Agents do not reply to agents in chat, and delegation between agents is bounded so no chain runs away." |
*
* @param {Mk_Sec_Pg_G6_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g6_d = /** @type {((inputs?: Mk_Sec_Pg_G6_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G6_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g6_d(inputs)
	return en_mk_sec_pg_g6_d(inputs)
});